module.exports = __webpack_public_path__ + "img/baiwan_pic.e029a686.png";